
export { defineGridPlugin } from './src/index';
